import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAppContext } from "../modules/appContext/AppContext";
import { OctResponse } from "../modules/models/OctResponse";
import { getErrorMessage } from "../modules/utils/AppFunction";
import { CODE } from "../modules/utils/Constant";

type Props = {
	initialQuery?: any;
	fetchApi: (params?: any) => Promise<OctResponse<any>>;
};

const useGetTableData = ({ initialQuery, fetchApi }: Props) => {
	const { setIsLoading } = useAppContext();
	const [data, setData] = useState<any>([]);
	const [query, setQuery] = useState<any>(initialQuery);
	const [refetchFlag, setRefetchFlag] = useState(false);
	const [paging, setPaging] = useState({
		totalPages: 0,
		totalElements: 0,
		numberOfElements: 0,
	});

	useEffect(() => {
		if (query) {
			getTableData(query);
		}
	}, [query, refetchFlag]);

	const getTableData = async (params: any) => {
		try {
			setIsLoading(true);
			const response = await fetchApi(params);
			const { code, data } = response ?? {};

			if (CODE.SUCCESS !== code) {
				toast.error(getErrorMessage(response));
				return;
			}

			setData(data);
			setPaging({
				totalPages: data.totalPages,
				totalElements: data.totalElements,
				numberOfElements: data.numberOfElements,
			});
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	const refetch = () => {
		setRefetchFlag(!refetchFlag);
	};

	return { query, setQuery, data, paging, refetch };
};

export default useGetTableData;
